module.exports = __webpack_public_path__ + "img/img-card.1cec605.png";